import { render, staticRenderFns } from "./PressInspectionTab.vue?vue&type=template&id=4c19747e&"
import script from "./PressInspectionTab.vue?vue&type=script&lang=js&"
export * from "./PressInspectionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports